/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsChevronMiniLeft: {
  name: 'chevron-mini-left';
  data: string;
} = {
  name: 'chevron-mini-left',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path fill-rule="evenodd" clip-rule="evenodd" d="M9.354 5.646a.5.5 0 0 1 0 .708L7.707 8l1.647 1.646a.5.5 0 0 1-.708.708l-2-2a.5.5 0 0 1 0-.708l2-2a.5.5 0 0 1 .708 0Z" fill="currentColor"/></svg>`,
};
